import { render, staticRenderFns } from "./productPic.vue?vue&type=template&id=1dcc5c27&scoped=true"
import script from "./productPic.vue?vue&type=script&lang=js"
export * from "./productPic.vue?vue&type=script&lang=js"
import style0 from "./productPic.vue?vue&type=style&index=0&id=1dcc5c27&prod&lang=scss&scoped=true"
import style1 from "./productPic.vue?vue&type=style&index=1&id=1dcc5c27&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcc5c27",
  null
  
)

export default component.exports